import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ServiceService } from '../../../services/service.service';

@Component({
  selector: 'app-activity-archive-page',
  templateUrl: './activity-archive-page.component.html',
  styleUrls: ['./activity-archive-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatCardModule,
    MatSnackBarModule,
    MatProgressSpinnerModule
  ]
})
export class ActivityArchivePageComponent implements OnInit {
  archivedActivities: any[] = [];
  displayedColumns: string[] = ['name', 'mainActivityType', 'store', 'duration', 'price', 'actions'];
  dataSource = new MatTableDataSource<any>();
  isLoading = false;
  storeId?: string;
  
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: ServiceService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.storeId = this.route.snapshot.queryParams['storeId'];
    this.loadArchivedActivities();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  loadArchivedActivities() {
    this.isLoading = true;
    
    if (this.storeId) {
      // Load archived activities for a specific store
      this.service.getArchivedActivitiesByStoreId(this.storeId).subscribe({
        next: (activities) => {
          this.archivedActivities = activities;
          this.dataSource.data = activities;
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error loading archived activities:', error);
          this.snackBar.open('Failed to load archived activities', 'Close', { duration: 3000 });
          this.isLoading = false;
        }
      });
    } else {
      // Load all archived activities
      this.service.getArchivedActivities().subscribe({
        next: (activities) => {
          this.archivedActivities = activities;
          this.dataSource.data = activities;
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error loading archived activities:', error);
          this.snackBar.open('Failed to load archived activities', 'Close', { duration: 3000 });
          this.isLoading = false;
        }
      });
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  unarchiveActivity(activity: any) {
    this.service.unarchiveActivity(activity.id).subscribe({
      next: () => {
        this.snackBar.open('Activity unarchived successfully', 'Close', { duration: 3000 });
        this.loadArchivedActivities();
      },
      error: (error) => {
        console.error('Error unarchiving activity:', error);
        this.snackBar.open('Failed to unarchive activity', 'Close', { duration: 3000 });
      }
    });
  }

  reuseActivity(activity: any) {
    // Navigate to store page with activity ID to create new availability
    this.router.navigate(['/store', activity.storeID], {
      queryParams: { 
        reuseActivityId: activity.id,
        activityName: activity.name
      }
    });
  }

  viewStore(activity: any) {
    if (activity.storeID) {
      this.router.navigate(['/store', activity.storeID]);
    }
  }
}


